// AuditPage.jsx
import React, { useEffect } from 'react';
import { Row, Col, Button, Table } from 'reactstrap';
import { Link } from 'react-router-dom';
import './Strategy.scss';
import xsimage from '../../assets/images/strategyxs.png'
const AuditPage = () => {
    <div className='xs-sv-page'>
    <img src={xsimage} />
</div>
    window.scroll(0, 0)

    useEffect(() => {
        window.scroll(0, 0)

        // Scroll animation observer
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.style.animation = 'fadeInUp 0.8s ease-out forwards';
                }
            });
        }, { threshold: 0.1 });

        document.querySelectorAll('[data-animated]').forEach(el => observer.observe(el));
        return () => observer.disconnect();
    }, []);

    const auditStats = [
        { number: '88%', label: 'of online consumers are less likely to return after a poor website experience' },
        { number: '3.5x', label: 'higher conversion rates with optimized user experiences and SEO' },
        { number: '70%', label: 'increase in customer satisfaction through improved UX design and site speed' },
        { number: '40%', label: 'reduction in bounce rates with enhanced user interfaces and mobile optimization' }
    ];

    const auditApproaches = [
        {
            icon: 'fas fa-desktop',
            title: 'Website Performance & User Experience Audit',
            desc: 'Comprehensive assessment of site speed, mobile responsiveness, usability, conversion paths, and technical factors that influence engagement and SEO rankings.'
        },
        {
            icon: 'fas fa-search',
            title: 'Technical SEO & Organic Search Analysis',
            desc: 'Detailed analysis of on-page SEO elements, keyword performance, backlink profile, technical SEO health, and competitor benchmarks for improved organic visibility.'
        },
        {
            icon: 'fas fa-ad',
            title: 'Paid Media & PPC Campaign Evaluation',
            desc: 'Thorough review of Google Ads, display, and social advertising campaigns to uncover budget inefficiencies and identify scaling opportunities for higher ROAS.'
        },
        {
            icon: 'fas fa-share-alt',
            title: 'Social Media & Content Strategy Assessment',
            desc: 'Evaluation of social media presence, content effectiveness, audience engagement metrics, and consistency with brand messaging across all platforms.'
        },
        {
            icon: 'fas fa-chart-bar',
            title: 'Analytics & Conversion Tracking Validation',
            desc: 'Ensuring accurate Google Analytics setup, reliable data sources, proper goal tracking, and meaningful KPIs that support data-driven decision-making.'
        },
        {
            icon: 'fas fa-chart-line',
            title: 'Competitive Benchmarking & Market Insights',
            desc: 'Comprehensive comparison of your digital performance against key competitors, identifying market gaps, areas of leadership, and improvement potential.'
        },
        {
            icon: 'fas fa-clipboard-check',
            title: 'Strategic Recommendations & Roadmap',
            desc: 'Detailed audit report with actionable insights, prioritized recommendations based on impact, and a clear roadmap for implementation and improvement.'
        }
    ];

    const benefits = [
        ['Transparent Performance Visibility', 'Know exactly how your digital channels perform across all touchpoints with comprehensive analytics'],
        ['Eliminate Marketing Inefficiencies', 'Stop wasting budget on low-impact tactics and focus on high-ROI activities that drive growth'],
        ['Improved ROI & Budget Optimization', 'Optimize marketing spend based on actionable insights and data-driven decisions for maximum returns'],
        ['Goal Alignment & Strategic Focus', 'Ensure all digital marketing activity supports your core business objectives and revenue goals'],
        ['Competitive Digital Advantage', 'Stay ahead of competitors through strategic insight, continuous optimization, and market adaptation']
    ];

    const targetBusinesses = [
        'Businesses unsure why their digital marketing results aren\'t meeting expectations',
        'Brands preparing to scale operations, pivot strategy, or enter new markets',
        'Companies launching new products, services, or major marketing campaigns',
        'Marketing teams lacking clarity on holistic digital performance across channels',
        'Companies seeking sustained, data-driven growth and continuous optimization',
        'Organizations planning to improve their SEO rankings and online visibility'
    ];

    const auditQuestions = [
        'Are your digital marketing channels working together effectively to drive conversions?',
        'Which parts of your marketing strategy are delivering real value — and which are falling short?',
        'Where are you missing opportunities for growth and optimization in your digital presence?',
        'What performance improvements can be quickly realized with minimal investment?',
        'How does your website and marketing performance compare to top competitors?'
    ];

    // SEO Keywords
    const keywords = [
        'digital marketing audit',
        'SEO audit services',
        'website performance audit',
        'PPC campaign evaluation',
        'social media audit',
        'marketing analytics review',
        'competitor benchmarking',
        'digital strategy optimization'
    ];

    return (
        <div className="strategy sv-page">
            {/* Decorative Image - Top of Page */}
            <div className="sv-decorative-image-container">

            </div>
            <div className='xs-sv-page'>
                <img src={xsimage} />
            </div>
            {/* Page Title Section */}
            <div className="sv-page-title-section">
                <div className="container">
                    <h1>
                        <span className="sv-gradient-text">Digital Marketing Audit</span> Services
                    </h1>
                    <p>Comprehensive performance analysis and strategic recommendations to maximize your online ROI and digital presence</p>
                </div>
            </div>

            {/* Main Content */}
            <div className="container-fluid sv-content-wrapper">
                <div className="sv-main-content">
                    {/* Hero Content Section */}
                    <section className="sv-hero-section" data-animated>
                        <Row className="align-items-center">
                            <Col lg={8}>
                                <p className="sv-lead">
                                    A <span className="sv-keyword-highlight">digital marketing audit</span> is a strategic evaluation of your entire digital ecosystem — covering everything from your website and SEO to social media, paid campaigns, content, and analytics.
                                </p>
                                <p className="sv-description">
                                    At Reachtix, our <strong>digital marketing audit services</strong> provide a deep, data-driven analysis of your current performance and deliver a clear roadmap for improvement — helping you make decisions rooted in insight, not guesswork. Our comprehensive <strong>SEO audit</strong> and <strong>website performance analysis</strong> identify critical opportunities for optimization.
                                </p>
                                <p className="sv-description">
                                    Rather than treating each channel in isolation, our audit assesses how all your digital efforts work together to drive growth, identify gaps, and uncover opportunities for optimisation across your entire <strong>digital marketing strategy</strong>.
                                </p>
                                <div className="sv-cta-buttons">
                                    <Button
                                        tag={Link}
                                        to="/contact"
                                        color='dark'
                                    >
                                        <i className="fas fa-rocket mr-2"></i>
                                        Start Your Digital Audit
                                    </Button>
                                    <Button
                                        tag={Link}
                                        to="/contact"
                                        color='dark'
                                    >
                                        <i className="fas fa-comments mr-2"></i>
                                        Get Free Consultation
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    </section>

                    {/* Stats Section */}
                    <section className="sv-stats-section">
                        <h2 className="sv-section-title" data-animated>
                            Why <span className="sv-text-gradient">Digital Marketing Audits</span> Matter for Your Business
                        </h2>
                        <Row className="sv-stats-grid">
                            {auditStats.map((stat, index) => (
                                <Col lg={6} md={6} key={index} className="mb-4" data-animated>
                                    <div className="sv-stat-card">
                                        <div className="sv-stat-number">{stat.number}</div>
                                        <div className="sv-stat-label">{stat.label}</div>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </section>

                    {/* What Is Audit Section */}
                    <section className="sv-explanation-section" data-animated>
                        <Row>
                            <Col lg={8}>
                                <h2 className="sv-section-title">What Is a Digital Marketing Audit?</h2>
                                <p className="sv-section-description">
                                    A <strong>digital marketing audit</strong> is essentially a digital health check-up for your brand. It evaluates how well your online activities are performing, where inefficiencies lie, and how your strategy can be improved to meet your goals. Our <strong>comprehensive audit services</strong> cover technical SEO, content effectiveness, user experience, and conversion optimization.
                                </p>
                                <div className="sv-questions-grid">
                                    <h4>Key Questions Our Digital Marketing Audit Answers:</h4>
                                    {auditQuestions.map((question, index) => (
                                        <div key={index} className="sv-question-item">
                                            <i className="fas fa-question-circle"></i>
                                            {question}
                                        </div>
                                    ))}
                                </div>
                            </Col>
                        </Row>
                    </section>

                    {/* Why Audit Section */}
                    <section className="sv-benefits-overview" data-animated>
                        <Row>
                            <Col xl={12}>
                                <h2 className="sv-section-title">Why Conduct a Digital Marketing Audit?</h2>
                                <p className="sv-section-description">
                                    A comprehensive audit provides the clarity and insights needed to drive smarter growth, optimize performance, and improve your <strong>SEO rankings</strong> across all digital channels.
                                </p>
                                <div className="sv-benefits-cards">
                                    <div className="sv-benefit-card">
                                        <i className="fas fa-search"></i>
                                        <h5>Clarity & Performance Visibility</h5>
                                        <p>Gain a clear view of what's working and what isn't across all digital marketing channels</p>
                                    </div>
                                    <div className="sv-benefit-card">
                                        <i className="fas fa-chart-line"></i>
                                        <h5>Data-Driven Marketing Decisions</h5>
                                        <p>Uncover insights based on real performance metrics and industry benchmarking</p>
                                    </div>
                                    <div className="sv-benefit-card">
                                        <i className="fas fa-rocket"></i>
                                        <h5>Performance Optimization</h5>
                                        <p>Better allocate budget, optimize campaigns and improve ROI across all marketing channels</p>
                                    </div>
                                    <div className="sv-benefit-card">
                                        <i className="fas fa-bullseye"></i>
                                        <h5>Strategic Business Alignment</h5>
                                        <p>Ensure digital activity aligns with business goals and adapts to market trends</p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </section>

                    {/* Our Audit Approach Section */}
                    <section className="sv-approach-section" data-animated>
                        <Row>
                            <Col >
                                <h2 className="sv-section-title">What Our Digital Marketing Audit Includes</h2>
                                <p className="sv-section-description">
                                    Reachtix takes a systematic, full-spectrum approach to auditing your digital ecosystem for maximum insight and actionable recommendations.
                                </p>

                                <div className="sv-approaches-grid">
                                    {auditApproaches.map((item, index) => (
                                        <div key={index} className="sv-approach-card">
                                            <div className="sv-approach-icon">
                                                <i className={item.icon}></i>
                                            </div>
                                            <div className="sv-approach-content">
                                                <h4>{item.title}</h4>
                                                <p>{item.desc}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </Col>
                        </Row>
                    </section>

                    {/* Benefits Section */}
                    <section className="sv-benefits-section" data-animated>
                        <Row>
                            <Col>
                                <h2 className="mt-5 sv-section-title">Benefits of Our Digital Marketing Audit Services</h2>
                                <div className="table-responsive">
                                    <Table borderless className="sv-benefits-table">
                                        <thead>
                                            <tr>
                                                <th>Core Benefit</th>
                                                <th>Business Impact</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {benefits.map(([benefit, impact], index) => (
                                                <tr key={index}>
                                                    <td>
                                                        <i className="fas fa-check-circle"></i>
                                                        <strong>{benefit}</strong>
                                                    </td>
                                                    <td>{impact}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>
                            </Col>
                        </Row>
                    </section>

                    {/* Who Should Invest Section */}
                    <section className="sv-target-section" data-animated>
                        <Row>
                            <Col>
                                <h2 className="sv-section-title">Who Needs a Digital Marketing Audit?</h2>
                                <p className="sv-section-description">
                                    Our <strong>digital marketing audit services</strong> deliver maximum value for businesses seeking clarity, optimization, and sustainable growth:
                                </p>
                                <div className="sv-target-list">
                                    {targetBusinesses.map((business, index) => (
                                        <div key={index} className="sv-target-item">
                                            <i className="fas fa-chevron-right"></i>
                                            {business}
                                        </div>
                                    ))}
                                </div>
                                <p className="sv-section-description mt-4">
                                    A <strong>digital marketing audit</strong> is valuable whether your marketing is underperforming or already doing well — it reveals potential you might be missing and provides a clear path to improvement.
                                </p>
                            </Col>
                        </Row>
                    </section>

                    {/* Final CTA Section */}


                    <section className="sv-main-cta" data-animated>
                        <Row>
                            <Col>
                                <h2>Ready to Understand Your Digital Performance?</h2>
                                <p className="sv-cta-description">
                                    Uncover the real story behind your online results and gain the clarity needed to drive smarter growth with our comprehensive <strong>digital marketing audit</strong>.
                                </p>
                                <p className="sv-cta-description">
                                    Reachtix brings strategic expertise, analytical precision and a business-first mindset to every audit, providing clear insights and practical next steps for your <strong>SEO</strong> and <strong>digital marketing</strong> success.
                                </p>
                                <div className="sv-cta-buttons">
                                    <Button
                                        tag={Link}
                                        to="/contact"
                                        color='primary'
                                    >
                                        <i className="fas fa-clipboard-check mr-2"></i>
                                        Schedule Your Digital Audit
                                    </Button>
                                    <Button
                                        tag={Link}
                                        to="/contact"
                                        color='light'
                                    >
                                        <i className="fas fa-comments mr-2"></i>
                                        Get Free Audit Consultation
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default AuditPage;